import { useQuery, UseQueryOptions } from "react-query";
import { MasterAPI } from "@/api/master";
import { SaloonAPI } from "@/api/saloon";
import { ClientsCacheService } from "@/services/clients/cache";
import type { tBizClient, eBizClientDomain } from "@/types";

type tRes = tBizClient[];
type tArgs = {
  domain: eBizClientDomain;
  saloonId?: string;
  masterId?: string;
};

export const useClientsListQuery = (
  { domain, saloonId, masterId }: tArgs,
  opts?: Omit<UseQueryOptions<tRes, unknown, tRes>, "queryKey" | "queryFn">
) => {
  const query = useQuery(
    ClientsCacheService.buildListQueryKey({
      domain,
      saloonId,
      masterId,
    }),
    async (): Promise<tRes> => {
      const api =
        domain === "saloon" ? SaloonAPI.getClients : MasterAPI.getClients;
      const ownerId = domain === "saloon" ? saloonId : masterId;
      const { data } = await api(ownerId);
      return data;
    },
    opts
  );
  return query;
};
